import React from 'react';
import styles from './Title.module.scss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useMediaQuery from '../hooks/useMediaQuery';
import { isMobileQuery } from '../MediaQuery/mediaQueryUtils';

const Title = ({ svg: SvgComponent, title, subtitle, iconSize, flex, subtitleMargin, outerClassName }) => {
    const isMobile = useMediaQuery(isMobileQuery);
    return (
        <div
            className={classNames(
                styles.title,
                { [styles['title--centered']]: isMobile && iconSize >= 40 },
                { [styles['title--flex']]: flex },
                outerClassName
            )}
        >
            {SvgComponent && <SvgComponent width={iconSize} />}
            {title && (
                <h1
                    className={classNames({
                        [styles['flex']]: flex,
                        [styles['small']]: iconSize < 40
                    })}
                >
                    {title}
                </h1>
            )}
            {subtitle && (
                <h6
                    className={classNames({
                        [styles['centered']]: isMobile && iconSize >= 40,
                        [styles['flex']]: flex,
                        [styles['subtitle_margin']]: subtitleMargin
                    })}
                >
                    {subtitle}
                </h6>
            )}
        </div>
    );
};

Title.propTypes = {
    svg: PropTypes.object,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    iconSize: PropTypes.number,
    flex: PropTypes.bool,
    subtitleMargin: PropTypes.bool,
    outerClassName: PropTypes.string
};

export default Title;
